import React from "react";
import AddImageButton from "./AddImageButton";
import AddVideoButton from "./AddVideoButton";

export default function AddFileButtons() {
    return (
        <div className="mb-5">
            <div className="mb-5 d-flex">
                <AddImageButton />
                <AddVideoButton />
            </div>
        </div>
    );
}
